var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFicelleStringLabelReference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.4 63.6",
    style: {
      enableBackground: "new 0 0 16.4 63.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#c0c0c0;stroke-linecap:round;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    className: "st0",
    d: "M13.9,61c0,0-11.7-8.6-11.7-19.5s12.7-16,12.7-25.7c0-5.7-3.1-11-8-13.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFicelleStringLabelReference);
export default __webpack_public_path__ + "static/media/ficelle-string-label-reference.19a60c5e0459b798eed762671ae158b7.svg";
export { ForwardRef as ReactComponent };